
export const data = [
    {
        Question: 'What is Redux?',
        Option1: 'Redux is State Management System',
        Option2: 'Redux is State',
        Option3: 'Redux is Data Type',
        Option4: 'Redux is a part of HTML'
    },
    {
        Question: 'What is the primary use of Redux?',
        Option1: 'To manage and centralize application state',
        Option2: 'To create CSS styles',
        Option3: 'To handle API requests',
        Option4: 'To manage HTML templates'
    },
    {
        Question: 'What are the core principles of Redux?',
        Option1: 'Single source of truth, state is read-only, changes are made with pure functions',
        Option2: 'State is shared, changes are made with impure functions',
        Option3: 'State is distributed, changes are automatic',
        Option4: 'None of the above'
    },
    {
        Question: 'What is a reducer in Redux?',
        Option1: 'A pure function that returns the next state',
        Option2: 'A function that fetches data',
        Option3: 'A tool to reduce the size of CSS',
        Option4: 'A method to combine components'
    },
    {
        Question: 'What is an action in Redux?',
        Option1: 'An object describing a state change',
        Option2: 'A function to fetch API data',
        Option3: 'A CSS property',
        Option4: 'A method to create components'
    },
    {
        Question: 'What does the Redux store do?',
        Option1: 'Holds the entire state of the application',
        Option2: 'Stores HTML templates',
        Option3: 'Stores CSS styles',
        Option4: 'Handles API requests'
    },
    {
        Question: 'What is middleware in Redux?',
        Option1: 'A way to handle asynchronous actions',
        Option2: 'A method to apply CSS styles',
        Option3: 'A function to create components',
        Option4: 'A way to combine reducers'
    },
    {
        Question: 'How is immutability maintained in Redux?',
        Option1: 'By avoiding direct state mutations',
        Option2: 'By using local storage',
        Option3: 'By modifying the DOM directly',
        Option4: 'By using impure functions'
    },
    {
        Question: 'What is the role of combineReducers in Redux?',
        Option1: 'To merge multiple reducers into one',
        Option2: 'To handle asynchronous actions',
        Option3: 'To fetch data from APIs',
        Option4: 'To initialize the store'
    },
    {
        Question: 'How does React integrate with Redux?',
        Option1: 'By using the React-Redux library',
        Option2: 'By directly modifying the store',
        Option3: 'By using inline CSS styles',
        Option4: 'By creating custom HTML tags'
    }
];
